import * as state from './state.js';
let getters = {
    getAllGrade: state => {
        return state.grades;
    },
    getProvinces: state => {
        return state.provinces;
    },
    getProvincesIdMap: state => {
        return state.provincesIdMap;
    },
    getCitysIdMap: state => {
        return state.citysIdMap;
    }
};
export default getters;


// WEBPACK FOOTER //
// ./src/vuex/modules/provincialGrade/getters.js